<template>
  <iframe
    :src="`https://player.vimeo.com/video/${vimeoId}?autoplay=1`"
    frameborder="0"
    allow="autoplay; fullscreen"
    allowfullscreen
    class="vimeo-player"
    ref="vimeo"
  ></iframe>
</template>

<script>
import Player from "@vimeo/player";

export default {
  name: "VimeoPlayer",
  props: {
    vimeoId: [String, Number],
    vimeoChapter: [String, Number],
    firstStartAt: [String, Number],
  },
  mounted() {
    this.player = new Player(this.$refs.vimeo);
    this.player.on("ended", () => {
      this.$root.$emit("nextVideo");
    });
    this.player.getChapters().then((chapters) => {
      this.chapters = chapters;
      if (this.vimeoChapter) this.goToChapter(this.vimeoChapter);
    });
    this.player.on("timeupdate", (data) => {
      const live_seconds = (Date.now() - this.releaseTime) / 1000;
      if (data.seconds > live_seconds) {
        this.player.setCurrentTime(live_seconds - 1);
      }
    });
    this.player.on("seeking", (data) => {
      const live_seconds = (Date.now() - this.firstStartAt) / 1000;
      if (data.seconds > live_seconds) {
        this.player.setCurrentTime(live_seconds - 1);
      }
    });
    this.player.on("chapterchange", (data) => {
      this.$root.$emit("chapterChange", {
        vimeo_id: this.vimeoId,
        vimeo_chapter: data.index - 1,
      });
    });
  },
  watch: {
    vimeoChapter() {
      this.goToChapter(this.vimeoChapter);
    },
  },
  methods: {
    goToChapter(c) {
      this.player.getCurrentChapter().then((current_chapter) => {
        if (c != current_chapter && this.chapters[c]) {
          this.player.setCurrentTime(this.chapters[c].startTime + 1);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.vimeo-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
